/* Céla — barre « livraison offerte » + compléments (panier et mini-panier)
   v29 : la barre est maintenant écrite par le thème (snippets/cart-summary.liquid) ; ce script ne
   l'ajoute plus quand le récapitulatif du thème est présent (évite qu'elle saute à chaque mise à jour).
   v22 : seuil de livraison offerte passé de 65 € à 35 €.
   Le seuil se calcule sur le total du panier après remises, comme au paiement.
   Si le seuil change dans Paramètres > Expédition et livraison, changer aussi THRESHOLD (en centimes). */
(function () {
  if (window.celaCartReady) return;
  window.celaCartReady = true;

  var THRESHOLD = 3500;

  function euro(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function barMarkup(sub) {
    var pct = Math.max(4, Math.min(100, Math.round((sub / THRESHOLD) * 100)));
    var msg;
    if (sub >= THRESHOLD) {
      msg = '<span class="cela-ship__done">Livraison offerte</span> — c\'est gagné.';
    } else {
      msg = 'Plus que <strong>' + euro(THRESHOLD - sub) + '</strong> et la livraison est offerte.';
    }
    return (
      '<p class="cela-ship__msg">' + msg + '</p>' +
      '<div class="cela-ship__track"><span class="cela-ship__fill" style="width:' + pct + '%"></span></div>'
    );
  }

  function renderBar(sub, count) {
    var hosts = document.querySelectorAll('.cart-summary__inner, .cart-drawer__summary');
    for (var i = 0; i < hosts.length; i++) {
      var host = hosts[i];
      var bar = host.querySelector('.cela-ship');
      /* Barre écrite par le thème (snippets/cart-summary.liquid) : on n'y touche pas */
      if (bar && bar.hasAttribute('data-serveur')) continue;
      if (host.querySelector('.cart-totals') && !bar) continue;
      if (count < 1) {
        if (bar) bar.remove();
        continue;
      }
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'cela-ship';
        host.insertBefore(bar, host.firstChild);
      }
      var next = barMarkup(sub);
      if (bar.innerHTML !== next) bar.innerHTML = next;
    }
  }

  function renderUpsell(handles, count) {
    var source = document.getElementById('cela-up-source');
    var scrollArea = document.querySelector('.cart-drawer__items');
    if (!source || !scrollArea) return;

    var holder = document.querySelector('.cela-up--drawer');

    if (count < 1) {
      if (holder) holder.remove();
      return;
    }

    var cards = source.content.cloneNode(true).querySelectorAll('.cela-up__card');
    var keep = [];
    for (var i = 0; i < cards.length && keep.length < 2; i++) {
      if (handles.indexOf(cards[i].getAttribute('data-cela-handle')) === -1) keep.push(cards[i]);
    }
    if (!keep.length) {
      if (holder) holder.remove();
      return;
    }

    var signature = keep
      .map(function (c) { return c.getAttribute('data-cela-handle'); })
      .join('|');

    var placed = holder && holder.parentNode === scrollArea;
    if (placed && holder.getAttribute('data-cela-sig') === signature) return;

    if (holder && !placed) holder.remove();
    if (!holder || !holder.isConnected) {
      holder = document.createElement('div');
      holder.className = 'cela-up cela-up--drawer';
    }
    if (holder.parentNode !== scrollArea) scrollArea.appendChild(holder);

    holder.setAttribute('data-cela-sig', signature);
    holder.innerHTML =
      '<p class="cela-up__eyebrow">Complétez votre rituel</p>' +
      '<p class="cela-up__note">Remise appliquée automatiquement, sans code.</p>' +
      '<ul class="cela-up__grid"></ul>';
    var list = holder.querySelector('.cela-up__grid');
    keep.forEach(function (card) { list.appendChild(card); });
  }

  var busy = false;
  function refresh() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (!c) return;
        var total = typeof c.total_price === 'number' ? c.total_price : c.items_subtotal_price;
        if (typeof total !== 'number') return;
        var handles = (c.items || []).map(function (i) { return i.handle; });
        renderBar(total, c.item_count);
        renderUpsell(handles, c.item_count);
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  var timer = null;
  function schedule(delay) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(refresh, delay || 350);
  }

  document.addEventListener('click', function () { schedule(450); }, true);
  document.addEventListener('change', function () { schedule(450); }, true);
  ['cart:update', 'cart:refresh', 'CartUpdateEvent', 'cart-update'].forEach(function (name) {
    document.addEventListener(name, function () { schedule(120); });
  });

  if (window.MutationObserver) {
    new MutationObserver(function () { schedule(250); }).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cela-add]');
    if (!button) return;
    event.preventDefault();
    if (button.dataset.celaBusy) return;
    button.dataset.celaBusy = '1';
    var label = button.textContent;
    button.textContent = 'Ajout…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(button.dataset.celaAdd), quantity: 1 }] }),
    })
      .then(function () { window.location.reload(); })
      .catch(function () {
        button.textContent = label;
        delete button.dataset.celaBusy;
      });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { schedule(100); });
  } else {
    schedule(100);
  }
})();
